import React from 'react';

import AppModal from '../../ui-components/AppModal';
import {
  formatCodeOrJson,
  formatTimestampToDateTime,
} from '../../utils/common';

import { LogDetailsModalProps } from './model';

const LogDetailsModal: React.FC<LogDetailsModalProps> = ({
  log,
  open,
  onClose,
}) => {
  if (!open || !log) {
    return null;
  }

  const metaDetail = formatCodeOrJson(
    typeof log.meta === 'string' ? log.meta : JSON.stringify(log.meta)
  );

  return (
    <AppModal isOpen={open} title="Log Details" onClose={onClose} hideFooter>
      <div className="flex gap-3 mb-4">
        {log.type && (
          <span className="bg-brand-500 text-white px-3 py-1 rounded-full text-sm">
            {log.type}
          </span>
        )}
        {log.systemInfo?.details?.os?.name && (
          <span className="bg-brand-500 text-white px-3 py-1 rounded-full text-sm">
            {log.systemInfo.details.os.name}
          </span>
        )}
        {log.systemInfo?.details?.browser?.name && (
          <span className="bg-brand-500 text-white px-3 py-1 rounded-full text-sm">
            {log.systemInfo.details.browser.name}{' '}
            {log.systemInfo.details.browser.version || ''}
          </span>
        )}
      </div>

      <div className="mb-3 text-left">
        <span className="font-bold">Error Message:</span>{' '}
        <span className="font-normal">{log.message}</span>
      </div>

      <div className="mb-3 text-left">
        <span className="font-bold">Date:</span>{' '}
        <span className="font-normal">
          {formatTimestampToDateTime(log.addedDate)}
        </span>
      </div>

      <div className="mb-2 text-left">
        <span className="font-bold">Other Detail:</span>
      </div>

      <div className="bg-gray-100 rounded border border-gray-300 h-[50vh] overflow-y-auto w-full">
        <pre className="text-pink-600 text-xs whitespace-pre-wrap break-words w-full p-3 m-0">
          {metaDetail}
        </pre>
      </div>
    </AppModal>
  );
};

export default LogDetailsModal;
